// MUI
import { Box, Fade } from "@mui/material";

// Components
import { LoadingSpinner } from "@/Layouts/components/LoadingSpinner";

// Helpers
import { and } from "@/Common/helpers/sonar";

const TableCustomComponents = ({ hasNextPage, isFetching, text }: { hasNextPage: boolean; isFetching: boolean; text: string }) => {
	return (
		<>
			{and(hasNextPage, isFetching) && (
				<Fade in={and(hasNextPage, isFetching)} timeout={400}>
					<Box className="mt-4">
						<LoadingSpinner label={text} className="items-center" />
					</Box>
				</Fade>
			)}
		</>
	);
};

export default TableCustomComponents;
